import React, { useEffect, useState } from 'react';
import { getAlertasPrecio, aplicarAlertaPrecio, descartarAlertaPrecio, getConfiguracion, updateConfiguracion } from '../services/api';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const pct = (n) => (Number(n) > 0 ? '+' : '') + Number(n || 0).toFixed(1) + '%';

export default function AlertasPrecio() {
  const [lista, setLista] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [msg, setMsg] = useState(null);
  const [umbral, setUmbral] = useState('');
  const [busyId, setBusyId] = useState(null);

  const flash = (ok, t) => { setMsg({ ok, t }); setTimeout(() => setMsg(null), 4000); };
  const load = () => getAlertasPrecio('pendiente').then(r => setLista(r.data.map(a => ({ ...a, precioEdit: a.precio_sugerido })))).catch(() => {}).finally(() => setCargando(false));

  useEffect(() => {
    load();
    getConfiguracion().then(r => setUmbral(r.data?.precio_umbral_alza_pct ?? 5)).catch(() => setUmbral(5));
    /* eslint-disable-next-line */
  }, []);

  const guardarUmbral = async () => {
    try { await updateConfiguracion({ precio_umbral_alza_pct: Number(umbral) }); flash(true, '✅ Umbral guardado'); }
    catch (e) { flash(false, '❌ No se pudo guardar el umbral'); }
  };

  const aplicar = async (a) => {
    setBusyId(a.id);
    try { const { data } = await aplicarAlertaPrecio(a.id, { precio: Number(a.precioEdit) }); flash(true, `✅ ${a.nombre}: precio actualizado a ${fmt(data.precio)}`); load(); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo aplicar')); }
    finally { setBusyId(null); }
  };
  const descartar = async (a) => {
    setBusyId(a.id);
    try { await descartarAlertaPrecio(a.id); load(); }
    catch (e) { flash(false, '❌ No se pudo descartar'); }
    finally { setBusyId(null); }
  };

  const setPrecio = (id, v) => setLista(ls => ls.map(a => a.id === id ? { ...a, precioEdit: v } : a));

  return (
    <div>
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>Alertas de precio</h1>
          <p style={s.sub}>Cuando el costo de compra de un producto sube más del umbral, el sistema sugiere un nuevo precio de venta que conserva tu margen. Tú apruebas.</p>
        </div>
        <div style={s.umbralBox}>
          <span style={{ color: '#94a3b8', fontSize: 13 }}>Avisar si el costo sube más de</span>
          <input type="number" step="0.5" style={s.umbralIn} value={umbral} onChange={e => setUmbral(e.target.value)} />
          <span style={{ color: '#94a3b8', fontSize: 13 }}>%</span>
          <button style={s.btnGhost} onClick={guardarUmbral}>Guardar</button>
        </div>
      </div>

      {msg && <div style={{ ...s.msg, background: msg.ok ? '#064e3b' : '#3f1d1d', color: msg.ok ? '#6ee7b7' : '#fca5a5' }}>{msg.t}</div>}

      <div style={s.card}>
        <table style={s.table}>
          <thead><tr>{['Producto', 'Costo anterior', 'Costo nuevo', 'Alza', 'Precio actual', 'Precio sugerido', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {cargando && <tr><td colSpan={7} style={s.empty}>Cargando…</td></tr>}
            {!cargando && lista.length === 0 && <tr><td colSpan={7} style={s.empty}>Sin alertas pendientes. Todo está en orden.</td></tr>}
            {lista.map(a => (
              <tr key={a.id}>
                <td style={{ ...s.td, color: '#e2e8f0' }}>{a.codigo ? <b style={{ color: '#93c5fd' }}>{a.codigo}</b> : ''} {a.nombre}</td>
                <td style={s.td}>{fmt(a.costo_anterior)}</td>
                <td style={{ ...s.td, color: '#fca5a5' }}>{fmt(a.costo_nuevo)}</td>
                <td style={s.td}><span style={s.badgeUp}>{pct(a.variacion_pct)}</span></td>
                <td style={s.td}>{fmt(a.precio_anterior)}</td>
                <td style={s.td}>
                  <span style={{ color: '#64748b', marginRight: 4 }}>$</span>
                  <input type="number" style={s.precioIn} value={a.precioEdit} onChange={e => setPrecio(a.id, e.target.value)} />
                </td>
                <td style={{ ...s.td, whiteSpace: 'nowrap' }}>
                  <button style={s.btnApply} disabled={busyId === a.id} onClick={() => aplicar(a)}>Aplicar</button>
                  <button style={s.btnDesc} disabled={busyId === a.id} onClick={() => descartar(a)}>Descartar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const s = {
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap', marginBottom: 14 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0, maxWidth: 620 },
  umbralBox: { display: 'flex', alignItems: 'center', gap: 8, background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: '8px 12px' },
  umbralIn: { width: 64, background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '6px 9px', color: '#f1f5f9', fontSize: 13 },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '7px 14px', fontSize: 13, cursor: 'pointer' },
  msg: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', whiteSpace: 'nowrap' },
  td: { padding: '10px 12px', color: '#94a3b8', borderBottom: '1px solid #16202e' },
  empty: { padding: 36, textAlign: 'center', color: '#64748b' },
  badgeUp: { background: '#7f1d1d', color: '#fca5a5', padding: '2px 9px', borderRadius: 12, fontSize: 12, fontWeight: 700 },
  precioIn: { width: 100, background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '6px 9px', color: '#6ee7b7', fontSize: 13, fontWeight: 600 },
  btnApply: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', marginRight: 6 },
  btnDesc: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '7px 12px', fontSize: 13, cursor: 'pointer' },
};
